import { render, staticRenderFns } from "./PendingOrderCardComponent.vue?vue&type=template&id=5709863a&"
import script from "./PendingOrderCardComponent.vue?vue&type=script&lang=js&"
export * from "./PendingOrderCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports